module.exports = __webpack_public_path__ + "img/Mixed-fruits-1200x790.b22dc3df.jpg";